package techla.base

@JsModule("uuid")
@JsNonModule
external val JsUUIDModule: dynamic

val uuidv4: () -> String = JsUUIDModule.v4
